export { default as reducer } from './promotion.ducks';



// WEBPACK FOOTER //
// ./src/routes/Promotion/index.ts